import * as React from "react"

function CloseCross(props) {
  return (
    <svg
     className="!h-[10px]"
      viewBox="0 0 11 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 .752l8.474 8.474M1 .752l8.474 8.474M1 9.248L9.474.774M1 9.248L9.474.774"
        stroke="currentColor"
        strokeLinecap="square"
      />
    </svg>
  )
}

export default CloseCross
